// import React from "react";
import useUkm from "../../../services/queries/useUkm";
import useUser from "../../../services/queries/useUser";
import useTimeAlt from "../../../services/queries/useTimeAlt";
import useSelectedUkm from "../../../services/queries/useSelectedUkm";

const initialParamsUkm = {
    size: 500,
    page: 1,
    search: "",
};

export default function useTransaksiPageData() {
    const { data: user, status: statusUser } = useUser();
    const { data: ukm, status: statusUkm } = useUkm(initialParamsUkm);
    const { data: time, status: statusTime } = useTimeAlt();

    const { ukmId, ukmData, isUkmTidakAktif: isTokoTidakAktif } = useSelectedUkm(user, ukm, time);

    const hasNoAccess =
        user?.aksesTransaksi === 0 || user?.aksesTransaksi === null;

    return {
        statusTime,
        statusUkm,
        statusUser,
        time,
        ukm,
        ukmData,
        ukmId,
        user,
        hasNoAccess,
        isTokoTidakAktif,
    };
}
